import React from 'react'
import { Box, Button, Card, CardContent, Chip, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import WhatsAppTestMessageForm from './WhatsAppTestMessageForm'

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 1040,
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
  },
  cardContent: {
    padding: theme.spacing(0),
    '&:last-child': {
      paddingBottom: 0,
    },
  },
  hero: {
    padding: theme.spacing(4),
    color: theme.palette.common.white,
    background:
      'radial-gradient(circle at top right, rgba(37, 211, 102, 0.42), transparent 34%), linear-gradient(135deg, #071b2c 0%, #10314c 52%, #0c5f54 100%)',
  },
  heroDescription: {
    maxWidth: 720,
    color: 'rgba(255, 255, 255, 0.86)',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
  },
  ycloudButton: {
    borderRadius: 999,
    fontWeight: 700,
    textTransform: 'none',
    borderColor: 'rgba(255, 255, 255, 0.6)',
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.common.white,
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  statusChip: {
    minHeight: 38,
    padding: theme.spacing(0.5, 1.25),
    fontWeight: 700,
    borderRadius: 999,
    color: '#083b22',
    backgroundColor: '#7CFFB2',
  },
  body: {
    padding: theme.spacing(3, 4, 4),
    background: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)',
  },
  kv: {
    marginBottom: theme.spacing(1),
  },
}))

export default function WhatsAppConnectionPanel() {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Box className={classes.hero}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={8}>
              <Typography variant="h5" gutterBottom>
                WhatsApp Business (YCloud)
              </Typography>
              <Typography className={classes.heroDescription} variant="body1">
                WhatsApp ahora opera mediante YCloud y plantillas aprobadas.
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className={classes.actions}>
                <Button
                  className={classes.ycloudButton}
                  variant="outlined"
                  size="small"
                  href="https://www.ycloud.com/console/#/app/inbox/chat"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ir a YCloud
                </Button>
                <Chip className={classes.statusChip} label="Activo / Configurado" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box className={classes.body}>

          <Box mt={2}>
            <Alert severity="info">Solo plantillas aprobadas disponibles. No existe envío libre en este flujo.</Alert>
          </Box>

          <WhatsAppTestMessageForm />
        </Box>
      </CardContent>
    </Card>
  )
}
